import bairro from '@/repositories/conecta-sus/cadastro/localizacao/bairroRepository'
import logradouro from '@/repositories/conecta-sus/cadastro/localizacao/logradouroRepository'
import loteamento from '@/repositories/conecta-sus/cadastro/localizacao/loteamentoRepository'

export default baseUrl => {

    return {
        bairro: bairro(baseUrl),
        logradouro: logradouro(baseUrl),
        loteamento: loteamento(baseUrl),
    }
}